export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4d8f1b3bd33f0f0bb34662ecbe5ba1b6d958920d&name=fetchTypeahead!'